export interface AppNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  data?: Record<string, any>;
  isRead: boolean;
  createdAt: string;
  link?: string;
}

/** Fixes up notification links from before /admin/users/edit/:id was the route */
const normalizeLink = (link?: string): string | undefined =>
  link?.replace(/^\/admin\/users\/(\d+)$/, "/admin/users/edit/$1");

/** Maps raw backend payload → AppNotification */
export const mapNotification = (n: any): AppNotification => ({
  id: String(n.id),
  type: n.type ?? "system",
  title: n.title ?? n.data?.title ?? "",
  message: n.message ?? n.data?.message ?? "",
  data: n.data,
  isRead: !!n.is_read,
  createdAt: n.created_at ?? new Date().toISOString(),
  link: normalizeLink(n.data?.url ?? n.link ?? undefined),
});
